export default [
  {
    component: () => import("pages/briefs/BriefPage.vue"),
    meta: {
      accessLevel: "organisation_edit",
      title: "Create Brief",
    },
    name: "briefs-add",
    path: "/organisations/:organisationId/briefs/new",
    props: true,
  },
  {
    component: () => import("pages/briefs/BriefPage.vue"),
    meta: {
      accessLevel: "organisation_edit",
      title: "Edit Brief",
    },
    name: "briefs-edit",
    path: "/organisations/:organisationId/briefs/:briefId/edit",
    props: true,
  },
];
